"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paraswap = void 0;
const web3_candies_1 = require("@defi.org/web3-candies");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const lodash_1 = __importDefault(require("lodash"));
var Paraswap;
(function (Paraswap) {
    const URL = "https://apiv5.paraswap.io";
    function findRoute(chainId, src, dst, amountIn, exchangeAdapter = web3_candies_1.zeroAddress, onlyDex, partner) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams({
                srcToken: src.address,
                destToken: dst.address,
                srcDecimals: src.decimals.toString(),
                destDecimals: dst.decimals.toString(),
                amount: amountIn.toString(),
                network: chainId.toString(),
                side: "SELL",
                maxImpact: "100",
                includeDEXS: onlyDex || "",
                partner: partner || "",
            });
            const response = yield fetch(`${URL}/prices/?${params}`);
            if (response.status < 200 || response.status >= 400)
                throw new Error(`${response.statusText}`);
            const route = (yield response.json()).priceRoute;
            const path = getDirectPath(route, onlyDex);
            let data = "0x";
            try {
                if (exchangeAdapter !== web3_candies_1.zeroAddress) {
                    data = yield buildSwapData(route, exchangeAdapter);
                }
            }
            catch (e) { }
            return { dstAmount: (0, bignumber_js_1.default)(route.destAmount), srcUsd: (0, bignumber_js_1.default)(route.srcUSD), dstUsd: (0, bignumber_js_1.default)(route.destUSD), data, path };
        });
    }
    Paraswap.findRoute = findRoute;
    function getDirectPath(route, onlyDex) {
        if (!onlyDex || !route.bestRoute.length)
            return [];
        const bestRoute = lodash_1.default.sortBy(route.bestRoute, (r) => r.percent).reverse()[0];
        if (bestRoute.swaps.length > 1)
            return []; // invalid direct path more than 1 path
        if (!(0, web3_candies_1.eqIgnoreCase)(bestRoute.swaps[0].srcToken, route.srcToken) ||
            !(0, web3_candies_1.eqIgnoreCase)(bestRoute.swaps[0].destToken, route.destToken))
            return []; //invalid direct path tokens
        const bestSwap = lodash_1.default.sortBy(bestRoute.swaps[0].swapExchanges, (s) => s.percent).reverse()[0];
        if (!onlyDex.split(",").includes(bestSwap.exchange))
            return []; // invalid direct path exchange
        const path = bestSwap.data.path;
        if (!path || path.length < 2)
            return []; // invalid direct path
        return path;
    }
    function buildSwapData(paraswapRoute, exchangeAdapter) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${URL}/transactions/${paraswapRoute.network}?ignoreChecks=true`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    priceRoute: paraswapRoute,
                    srcToken: paraswapRoute.srcToken,
                    destToken: paraswapRoute.destToken,
                    srcDecimals: paraswapRoute.srcDecimals,
                    destDecimals: paraswapRoute.destDecimals,
                    srcAmount: paraswapRoute.srcAmount,
                    destAmount: "1",
                    userAddress: exchangeAdapter,
                }),
            });
            if (response.status < 200 || response.status >= 400)
                throw new Error(`${response.statusText}`);
            return (yield response.json()).data;
        });
    }
})(Paraswap = exports.Paraswap || (exports.Paraswap = {}));
